import React, { FC } from 'react';
import '../../views/writing/slice/slice';
import { FitText } from '../FitText/FitText';

type CardProps = {
  id: any,
  content: string,
};

export const WordFromList: FC<CardProps> = ({
  content, id,
}) => (
  <>
    {/* Długi zwrot dostaje mniejszą czcionkę, żeby zmieścił się w karcie (na telefonie) */}
    <FitText
      className="word"
      id={id}
    >
      {content}
    </FitText>
  </>
);

export default WordFromList;
